import IconProps from './IconProps';

function ChecklistIcon({ color }: IconProps) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
			<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
				<g fill={color ?? '#C2CAD2'} fillRule="nonzero" transform="translate(-375 -960)">
					<path d="M388.867 976h-11.734a2.133 2.133 0 01-2.133-2.133v-11.733c0-1.179.955-2.134 2.133-2.134h11.734c1.178 0 2.133.955 2.133 2.134v11.733a2.133 2.133 0 01-2.133 2.133zm1.067-13.866c0-.59-.478-1.067-1.067-1.067h-11.734c-.589 0-1.067.478-1.067 1.067v11.733c0 .59.478 1.067 1.067 1.067h11.734c.589 0 1.067-.477 1.067-1.067v-11.733zm-7.302 9.371c-.018.025-.028.054-.05.077a.515.515 0 01-.382.15.513.513 0 01-.381-.15c-.023-.023-.033-.051-.05-.077l-3.395-3.098a.522.522 0 010-.779.63.63 0 01.842 0l2.984 2.836 4.637-6.04c.22-.21.578-.21.798 0 .22.212.22.554 0 .766l-5.003 6.315z" />
				</g>
			</g>
		</svg>
	);
}

export default ChecklistIcon;
